import React, { Component } from 'react';
import { connect } from "react-redux";
import { openPullout } from "../../Actions/endUserActions"

import axios from "axios";
import moment from "moment";

class EUSidebarBookingCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
    }

    openBooking() {

    }

    render() {
        return (
            <a className="eu-sidebar-booking-card mb-16" onClick={() => this.props.dispatch(openPullout(this.props.booking))}>
                <div className="eu-sidebar-booking-card-left">
                    <h2>{this.props.booking.vehicle.Year} {this.props.booking.vehicle.Make} {this.props.booking.vehicle.Model} {this.props.booking.vehicle.Trim}</h2>
                    <div className="eu-sidebar-booking-card-dates">
                        <div className="eu-sidebar-booking-card-dates-pickup">
                            <p className = 'eu-sidebar-booking-card-dates-date'>{moment(this.props.booking.Start_Date).format('MMM DD, YYYY')}</p>
                            <p className = 'eu-sidebar-booking-card-dates-time'>{moment(this.props.booking.Release_Time, "HH:mm:ss").format("h:mm A")}</p>
                        </div>
                        <div className="eu-sidebar-booking-card-dates-arrow">
                        <i className="fas fa-long-arrow-alt-right"></i>
                        </div>
                        <div className="eu-sidebar-booking-card-dates-dropoff">
                            <p className = 'eu-sidebar-booking-card-dates-date'>{moment(this.props.booking.End_Date).format('MMM DD, YYYY')}</p>
                            <p className = 'eu-sidebar-booking-card-dates-time'>{moment(this.props.booking.Return_Time, "HH:mm:ss").format("h:mm A")}</p>
                        </div>
                    </div>
                </div>
                <div className="eu-sidebar-booking-card-right"  onClick={() => this.props.dispatch(openPullout(this.props.booking))}>
                    <i className="fas fa-chevron-right primary"></i>
                </div>
            </a>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser
});

export default connect(mapStateToProps)(EUSidebarBookingCard);